import React from "react";
import "./Enterprise.scss";
import { Link } from "react-router-dom";

const GetStarted = () => {
  return (
    <div>
      <div className="get-started-background">
        <div className="get-started-content">
          <div className="get-started-text">
            Ready to <span>Get Started?</span>
          </div>
          <div className="signup-plans-buttons-get-started">
            <div className="button-wrapper-plans-get-started">
              <div className="btn-plans-get-started cta">
                <Link to="/pricing">
                  <span>Plans & Pricing</span>
                </Link>
              </div>
            </div>
            <div className="button-wrapper-signup-get-started">
              <div className="btn-signup-get-started cta">
                <Link to={{ pathname: "/pricing", state: "lite" }}>
                  <span>Sign up, It's free</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetStarted;
